/// <reference types="./copy.d.mts" />
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $svg from "../../ds/internals/svg.mjs";
import { toList } from "../../gleam.mjs";

export function copy() {
  return $svg.square_(
    256,
    toList([$a.attribute("fill", "currentColor")]),
    "<rect width=\"256\" height=\"256\" fill=\"none\"/>\n      <polyline points=\"168 168 216 168 216 40 88 40 88 88\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\"/>\n      <rect x=\"40\" y=\"88\" width=\"128\" height=\"128\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\"/>",
  );
}
